import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesPartCategoriesDataGrid } from "src/components/views/erp/sales/masterData/salesPartCategories/SalesPartCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesPartCategories")({
	staticData: { title: i18n.t("sales_part_categories"), legacyViewKey: "salesPartCategoriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesPartCategoriesDataGrid />;
}
